/**
 * Treine seu agente — orquestrador; lógica em features/training/
 */
import React from 'react';
import { useTrainAgentState } from '../features/training/useTrainAgentState';
import { styles } from '../features/training/trainAgentStyles';
import { TrainAgentMessageBanner } from '../features/training/TrainAgentMessageBanner';
import { TrainAgentSelectors } from '../features/training/TrainAgentSelectors';
import { TrainAgentTierBlock } from '../features/training/TrainAgentTierBlock';
import { TrainAgentRoleBlock } from '../features/training/TrainAgentRoleBlock';
import { TrainAgentConstraintsBlock } from '../features/training/TrainAgentConstraintsBlock';
import { TrainAgentToneBlock } from '../features/training/TrainAgentToneBlock';
import { TrainAgentCompanyBlock } from '../features/training/TrainAgentCompanyBlock';
import { TrainAgentExamplesBlock } from '../features/training/TrainAgentExamplesBlock';
import { TrainAgentArgumentsBlock } from '../features/training/TrainAgentArgumentsBlock';
import { TrainAgentCtaBlock } from '../features/training/TrainAgentCtaBlock';
import { TrainAgentMediaBlock } from '../features/training/TrainAgentMediaBlock';
import { TrainAgentSaveBar } from '../features/training/TrainAgentSaveBar';
import { TrainAgentHelpVideos } from '../features/training/TrainAgentHelpVideos';

const TrainAgent = () => {
  const vm = useTrainAgentState();
  const { bot, loading, selectedBotId, message } = vm;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Treine seu agente</h2>
      <p style={styles.subtitle}>
        Selecione o cliente e o bot. Edite os 6 blocos de treino e salve. Opcional: envie arquivos .txt, .docx ou .pdf
        para Informações da empresa.
      </p>

      <TrainAgentMessageBanner message={message} />

      <div style={styles.form}>
        <TrainAgentSelectors vm={vm} />

        {loading && !bot && selectedBotId && <div style={styles.loading}>Carregando bot...</div>}

        {bot && (
          <>
            <TrainAgentTierBlock vm={vm} />
            <TrainAgentRoleBlock vm={vm} />
            <TrainAgentConstraintsBlock vm={vm} />
            <TrainAgentToneBlock vm={vm} />
            <TrainAgentCompanyBlock vm={vm} />
            <TrainAgentExamplesBlock vm={vm} />
            <TrainAgentArgumentsBlock vm={vm} />
            <TrainAgentCtaBlock vm={vm} />
            <TrainAgentMediaBlock vm={vm} />
            <TrainAgentSaveBar vm={vm} />
          </>
        )}
      </div>

      <TrainAgentHelpVideos />
    </div>
  );
};

export default TrainAgent;
